import { useContext, createContext } from 'react';
import IAppContext from './AppContext';
import { initialAppState } from './useAppReducer';

export const AppContext = createContext<IAppContext>({ state: initialAppState, dispatch: () => null });

export const useAppContext = () => useContext(AppContext);
